import React, { useState, useEffect, useCallback } from 'react'
import {
  ReactFlow,
  Background,
  useNodesState,
  useEdgesState,
  Handle,
  Position,
  addEdge,
  MiniMap,
  Controls,
} from '@xyflow/react'
import '@xyflow/react/dist/style.css'
import useAxios from '../../../lib/auth/useAxios'
import { Button, Modal, Menu, Table } from 'semantic-ui-react'
import MickeyForm from '../../../components/Forms/MickeyForm'
import MickeyTable from '../../../components/MickeyTable/MickeyTable'
import OrderCargoDetailsRow from '../../buyer/Orders/OrderCargoDetailsRow'

const EmailSettings = (props) => {
  const { openAddModal, setOpenAddModal } = props
  const axios = useAxios()
  const [loading, setLoading] = useState(false)
  const [reload, setReload] = useState(false)
  const [emailInjestions, setEmailInjestions] = useState({
    nodes: [],
    edges: [],
  })

  // Custom node component to handle text overflow
  const CustomNode = ({ data }) => {
    return (
      <div className="ui segment">
        <Handle type="target" position={Position.Top} />
        <div className="text-sm break-words text-center overflow-hidden">
          {data.label}
        </div>
        <Handle type="source" position={Position.Bottom} />
      </div>
    )
  }

  const nodeTypes = {
    custom: CustomNode,
  }
  const getNodes = (response) => {
    const nodes = []
    const edges = []

    let i = 0
    response.forEach((ej) => {
      const emailNodeId = `email-${ej.id}`
      const itemNodeId = `item-${ej.id}`

      nodes.push(
        {
          id: emailNodeId,
          data: { label: ej.email_address },
          position: { x: 300 * i + 100, y: -100 },
          type: 'custom',
        },
        {
          id: itemNodeId,
          data: { label: ej.mapping_model },
          position: { x: 300 * i + 100, y: 100 },
          type: 'custom',
        }
      )

      edges.push({
        id: `${emailNodeId}-${itemNodeId}`,
        source: emailNodeId,
        label: 'Injesting Emails and Creating...',
        target: itemNodeId,
        animated: true,
      })
      i += 1
    })

    return { nodes, edges }
  }
  useEffect(() => {
    async function fetchEmailInjestions() {
      try {
        setLoading(true)
        const response = await axios.get('/main/email-injestions/', {})
        const { nodes, edges } = getNodes(response.data.results)
        setEmailInjestions({ nodes, edges })
      } catch (error) {
        console.error('Error fetching email injestions:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchEmailInjestions()
  }, [reload])

  const defaultViewport = { x: 0, y: 0, zoom: 0.8 }

  const [nodes, setNodes, onNodesChange] = useNodesState([])
  const [edges, setEdges, onEdgesChange] = useEdgesState([])
  const [bgColor, setBgColor] = useState('#000')
  const [activeItem, setActiveItem] = useState('mappings')

  const handleItemClick = (e, { name }) => setActiveItem(name)

  return (
    <div style={{ width: '100%', height: '900px', padding: '20px' }}>
      <Menu pointing secondary>
        <Menu.Item
          name="mappings"
          active={activeItem === 'mappings'}
          onClick={handleItemClick}
        />
        <Menu.Item
          name="ingestion log"
          active={activeItem === 'ingestion log'}
          onClick={handleItemClick}
        />
      </Menu>
      {activeItem === 'mappings' && (
        <ReactFlow
          nodes={emailInjestions.nodes}
          edges={emailInjestions.edges}
          onNodesChange={onNodesChange}
          onEdgesChange={onEdgesChange}
          fitView
          // onConnect={onConnect}
          nodeTypes={nodeTypes}
          snapToGrid={true}
          snapGrid={true}
          defaultViewport={defaultViewport}
          fitView
          attributionPosition="bottom-left"
        >
          <MiniMap
            nodeStrokeColor={(n) => {
              if (n.type === 'input') return '#0041d0'
              if (n.type === 'selectorNode') return bgColor
              if (n.type === 'output') return '#ff0072'
            }}
            nodeColor={(n) => {
              if (n.type === 'selectorNode') return bgColor
              return '#fff'
            }}
          />
          <Background />
          <Controls />
        </ReactFlow>
      )}
      {activeItem === 'ingestion log' && (
        <div>
          <MickeyTable
            headerRow={['Type', 'Email', 'Business', '']}
            url={'/main/email-injestion-actions/'}
            reload={reload}
            setReload={setReload}
            renderBodyRow={(data, index) => {
              return (
                <Table.Row>
                  <Table.Cell>{data?.mapping_model}</Table.Cell>
                  <Table.Cell>{data.email_address}</Table.Cell>
                  <Table.Cell>{data?.user?.business?.name}</Table.Cell>
                </Table.Row>
              )
            }}
            urlParams={{
              archived: 'False',
            }}
            emptyIcon={'file'}
            emptyMessage={'Email Injestion Activity will populate here'}
          />
        </div>
      )}
      <Modal
        onClose={() => setOpenAddModal(false)}
        onOpen={() => setOpenAddModal(true)}
        open={openAddModal}
      >
        <Modal.Header>Add Email Injestion</Modal.Header>
        <Modal.Content>
          <MickeyForm
            formName={'EmailInjestionForm'}
            model={'EmailInjestion'}
            url={'/main/email-injestions/'}
            tenantAware={false}
            handleForm={(status, data) => {
              if (status === 'success') {
                setReload(true)
                setOpenAddModal(false)
              }
            }}
          />
        </Modal.Content>
      </Modal>
    </div>
  )
}

export default EmailSettings
